"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectedErrorAsRecord = exports.expectedErrorAsPlusPlusPlus = exports.expectedError = void 0;
const plus_plus_plus_1 = require("../exceptions/plus-plus-plus");
function expectedError(fn) {
    let result, error;
    try {
        result = fn();
    }
    catch (err) {
        error = err;
    }
    if (result) {
        throw new Error('Expecting passed-in function to throw an error');
    }
    return error;
}
exports.expectedError = expectedError;
function expectedErrorAsPlusPlusPlus(fn) {
    return new plus_plus_plus_1.PlusPlusPlus(expectedError(fn));
}
exports.expectedErrorAsPlusPlusPlus = expectedErrorAsPlusPlusPlus;
function expectedErrorAsRecord(fn) {
    return expectedErrorAsPlusPlusPlus(fn).toJSON();
}
exports.expectedErrorAsRecord = expectedErrorAsRecord;
//# sourceMappingURL=expected-error.js.map